import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Component, Inject } from '@angular/core';
import { NotificationToastService } from 'src/app/services/notification-toast.service';

@Component({
    selector: 'app-medical-order-scann-view-dialog',
    templateUrl: 'medical-order-scann-view-dialog.component.html',
    styleUrls: ['./medical-order-scann-view-dialog.component.css']
  })
  export class MedicalOrderScannViewComponent {
    medicalorderId: number;
    constructor(public dialogRef: MatDialogRef<any>
      , @Inject(MAT_DIALOG_DATA) public data: any) {
        this.medicalorderId = this.data.medicalorderId;
    }

    onNoClick($event): void {
        this.dialogRef.close(false);
    }
  }
